import { render, staticRenderFns } from "./Shot.vue?vue&type=template&id=2103ec71&scoped=true&"
import script from "./Shot.vue?vue&type=script&lang=js&"
export * from "./Shot.vue?vue&type=script&lang=js&"
import style0 from "./Shot.vue?vue&type=style&index=0&id=2103ec71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2103ec71",
  null
  
)

export default component.exports